import { useState } from "react";
import tabletrans from "../../translate/tables";
import Status from "../Components/Status";
import { normalPriceCount } from "../../env";

function DTableRow(props) {
  const order = props.order;
  // let totalPrice = 0
  // const total = order.price.map(price)=>(
  //   totalPrice =totalPrice + price
  // )

  return (
    <tr>
      <td>{props.index + 1}</td>
      <td>{order.sku}</td>
      <td style={{ whiteSpace: "nowrap", fontSize: ".75rem" }}>
        {order.title}
      </td>
      <td>{order.count}</td>
      <td>{normalPriceCount(order.fullPrice)}</td>
    </tr>
  );
}
export default DTableRow;
